// src/pages/Dashboard.jsx

import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';

const Dashboard = () => {
  const [loading, setLoading] = useState(true);

  const [stats, setStats] = useState({
    totalPlayPoints: 0,
    totalWinPoints: 0,
    totalCommission: 0,
    totalUnclaimed: 0,
    totalBets: 0,
    endPoint: 0,
    net: 0,
    gameBreakdown: {},
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await api.get('/admin/dashboard/stats');

      setStats({
        totalPlayPoints: response.data.totalPlayPoints || 0,
        totalWinPoints: response.data.totalWinPoints || 0,
        totalCommission: response.data.totalCommission || 0,
        totalUnclaimed: response.data.totalUnclaimed || 0,
        totalBets: response.data.totalBets || 0,
        endPoint: response.data.endPoint || 0,
        net: response.data.net || 0,
        gameBreakdown: response.data.gameBreakdown || {},
      });

      setLoading(false);
    } catch (error) {
      console.error('Dashboard Error:', error);
      toast.error('Failed to load dashboard data');
      setLoading(false);
    }
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
  };

  const getGameName = (key) => {
    switch (key) {
      case 'classic':
        return 'Royal King';
      case 'roulette':
        return 'Roulette';
      case 'funtarget':
        return 'Fun Target';
      default:
        return key;
    }
  };

  const overallStatCards = [
    {
      title: 'Total Bets',
      value: stats.totalBets,
      color: 'orange',
    },
    {
      title: 'Total PlayPoints',
      value: formatAmount(stats.totalPlayPoints),
      color: 'purple',
    },
    {
      title: 'Total WinPoints',
      value: formatAmount(stats.totalWinPoints),
      color: 'pink',
    },
    {
      title: 'End Point',
      value: formatAmount(stats.endPoint),
      color: 'blue',
    },
    // {
    //   title: 'Total Commission',
    //   value: formatAmount(stats.totalCommission),
    //   color: 'green',
    // },
    // {
    //   title: 'Total Unclaimed',
    //   value: formatAmount(stats.totalUnclaimed),
    //   color: 'red',
    // },
    // {
    //   title: 'Net',
    //   value: formatAmount(stats.net),
    //   color: 'blue',
    // },
  ];

  if (loading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  return (
    <div className="dasboard-page">
      <div className="container-fluid">

        <h1 className="page-heading">Dashboard Overview</h1>

        {/* ================= TODAY STATS ================= */}

        {Object.entries(stats.gameBreakdown).map(([gameKey, game]) => {
          const todayEndPoint =
            (game.todayPlayPoints || 0) -
            (game.todayWinPoints || 0);

          return (
            <div key={`today-${gameKey}`} className="mb-5">
              <h2 className="das-heading-two">
                Today's Statistics {getGameName(gameKey)}
              </h2>

              <div className="row g-4">
                <div className="col-lg-4 col-md-6">
                  <div className="stat-card purple">
                    <p>Today's PlayPoints</p>
                    <h3>{formatAmount(game.todayPlayPoints)}</h3>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="stat-card pink">
                    <p>Today's WinPoints</p>
                    <h3>{formatAmount(game.todayWinPoints)}</h3>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="stat-card blue">
                    <p>Today's End Point</p>
                    <h3>{formatAmount(todayEndPoint)}</h3>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        {/* ================= OVERALL GAME STATS ================= */}

        {Object.entries(stats.gameBreakdown).map(([gameKey, game]) => {
          const overallEndPoint =
            (game.totalPlayPoints || 0) -
            (game.totalWinPoints || 0);

          return (
            <div key={`overall-${gameKey}`} className="mb-5">
              <h2 className="das-heading-two">
                Overall Statistics {getGameName(gameKey)}
              </h2>

              <div className="row g-4">
                <div className="col-lg-3 col-md-6">
                  <div className="stat-card orange">
                    <p>Total Bets</p>
                    <h3>{game.totalBets || 0}</h3>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="stat-card purple">
                    <p>Total PlayPoints</p>
                    <h3>{formatAmount(game.totalPlayPoints)}</h3>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="stat-card pink">
                    <p>Total WinPoints</p>
                    <h3>{formatAmount(game.totalWinPoints)}</h3>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="stat-card blue">
                    <p>Overall End Point</p>
                    <h3>{formatAmount(overallEndPoint)}</h3>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        {/* ================= COMBINED OVERALL ================= */}

        <div className="mb-5">
          <h2 className="das-heading-two">
            Combined Overall Statistics
          </h2>

          <div className="row g-4">
            {overallStatCards.map((stat, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className={`stat-card ${stat.color}`}>
                  <p>{stat.title}</p>
                  <h3>{stat.value}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Dashboard;